import React from 'react'

export default function ErrorIndicator({ error }) {
    return (
        <div className="notification is-danger mt-3" role="alert">
            <h5 className='alert-heading'>
                <strong>Error</strong>
            </h5>
            {error?.response_json?.error?.message || error?.message || error}
        </div>
    )
}
